// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kd-1";
export var messageSideRight = "_kd-2";
export var orderLookupBubbleContainer = "_kd-0";
export var submitButton = "_kd-3";